export type ParsedMenuUrl = {
  urlSlug: string;
  menuId: string | undefined;
};

/**
 * | Path                       | urlSlug      | menuId                   |
 * |----------------------------|--------------|--------------------------|
 * | /{urlSlug}                 | urlSlug      | ?menuId=                 |
 * | /{city}/{urlSlug}          | city/urlSlug | ?menuId=                 |
 * | /{city}/{urlSlug}/{menuId} | city/urlSlug | ?menuId=, else segment 3 |
 *
 * The backend resolves `city/urlSlug` as one menu URL. Kept free of imports so
 * it can be inlined into a static page's script.
 */
export function parseMenuUrl(pathname: string, search: string): ParsedMenuUrl {
  const pathParts = pathname.split("/").filter(Boolean);
  const queryMenuId = new URLSearchParams(search).get("menuId") || undefined;

  let urlSlug = "";
  if (pathParts.length === 1) {
    urlSlug = pathParts[0];
  } else if (pathParts.length >= 2) {
    urlSlug = `${pathParts[0]}/${pathParts[1]}`;
  }

  return { urlSlug, menuId: queryMenuId || pathParts[2] || undefined };
}
